import { RootState } from '@/App/store';

export const selectDeleteProfile = (state: RootState) => state.deleteProfile;
